export default __webpack_public_path__ + "static/media/The3Dicketeers.415ddba6.PNG";